<template>
  <!-- D: MO전용 뒤로가기&타이틀 -->
  <header class="l-header-mo" v-show="showHeaderRouteCheck()">
    <button type="button" class="history-back" @click="btnCmd('goBack')">
      <i class="c-icon icon-back"></i>
      <span class="sr-only">뒤로가기</span>
    </button>
    <h1 class="title">{{ getPageTitle() }}</h1>
  </header>
</template>

<script setup name="footer1_mo">
import { ref, defineProps } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import * as cmUtil from "@/utils/cmUtil.js";
const { isMobile, isTablet } = cmUtil.useDeviceType();
const router = useRouter();
const route = useRoute();

let routeChange = ref([]);

defineProps({
  titleName: String,
});

const isMatchRouteMultiple = (route, paths = []) => {
  // 아래 조건은 정확히 일치할 때만 true 반환
  if (route.path === "/") {
    return paths.includes("/");
  }
  if (route.path === "/member") {
    return paths.includes("/member");
  }

  // 나머지 경로는 includes로 체크
  return paths.some((path) => {
    // 제외하고 체크
    if (path === "/") return false;
    if (path === "/member") return false;

    return route.path.includes(path);
  });
};
const showHeaderRouteCheck = () => {
  /* MEMO
    1. MO에서 historyBack 노출해야하는 경우는 isMobie 조건에 추가
    1. 태블릿에서 헤더 비노출, historyBack 나와야하면 외 조건에 추가
  */
  if (isMobile.value) {
    routeChange.value = [
      "/member", // 임시
      "/member/idsrch", // 임시
      "/member/pwdsrch", // 임시
      "/paintpro/member",
      "/paintpro/member/idsrch",
      "/paintpro/member/pwdsrch",
      "/paintpro/orderBasket",
      "/paintpro/orderOrder",
      "/paintpro/orderList/detail",
      "/paintpro/search",
      "/paintpro/quickMenu/rcentlyViewedProd",
      "/paintpro/utility",
    ];
  } else if (isTablet.value) {
    routeChange.value = [
      "/member", // 임시
      "/member/idsrch", // 임시
      "/member/pwdsrch", // 임시
      "/paintpro/member",
      "/paintpro/member/idsrch",
      "/paintpro/member/pwdsrch",
    ];
  }

  return isMatchRouteMultiple(route, routeChange.value);
};

async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "goBack") {
    if (route.path.indexOf("/paintpro/utility") > -1) {
      router.push("/paintpro/main");
    } else if (window.history.length > 1) {
      window.history.back(); // 브라우저 히스토리가 1보다 크면 이전 페이지로 돌아감
    } else {
      router.push("/"); // 히스토리가 없으면 특정 페이지로 리디렉션 (예: 홈 페이지)
    }
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}

// prefix paths
const addPrefixPaths = (paths) => {
  const prefixes = [""];

  return paths.reduce((acc, path) => {
    // 기본 경로 추가
    acc.push(path);

    // 각 prefix 추가
    prefixes.forEach((prefix) => {
      if (!path.startsWith(prefix)) {
        acc.push(`${prefix}${path}`);
      }
    });

    return acc;
  }, []);
};

// title data
const PAGE_TITLES = {
  memberJoin: {
    paths: addPrefixPaths([
      "/member", // 임시
      "/member/join", // 임시
      "/paintpro/member",
      "/paintpro/join",
    ]),
    title: "회원가입",
  },
  idSrch: {
    paths: addPrefixPaths(["/member/idsrch"]), // 임시
    title: "아이디 찾기",
  },
  pwSrch: {
    paths: addPrefixPaths(["/member/pwdsrch"]), // 임시
    title: "비밀번호 찾기",
  },
  orderListDetail: {
    paths: addPrefixPaths(["/paintpro/orderList/detail"]),
    title: "주문상세",
  },
  moOrderListDetail: {
    paths: addPrefixPaths(["/paintpro/orderList/moListDetail"]),
    title: "출고현황 상세보기",
  },
  orderOrder: {
    paths: addPrefixPaths(["/paintpro/orderOrder"]),
    title: "주문서 작성",
  },
  myInfo: {
    paths: addPrefixPaths(["/paintpro/utility"]),
    title: "내정보",
  },
  recentProducts: {
    paths: addPrefixPaths(["/paintpro/quickMenu/rcentlyViewedProd"]),
    title: "최근 본 제품",
  },
  cart: {
    paths: addPrefixPaths(["/paintpro/orderBasket"]),
    title: "장바구니",
  },
  search: {
    paths: addPrefixPaths(["/paintpro/search"]),
    title: "검색결과",
  },
};

// title 출력
const getPageTitle = () => {
  const pageConfig = Object.values(PAGE_TITLES).find((config) =>
    isMatchRouteMultiple(route, config.paths)
  );
  return pageConfig?.title || "";
};
</script>
